import React from 'react';
import { useSmartTableWithQueryParams } from '@weezevent/smart-table';
import { useSmartTableQuery } from '../../manager/components/context';
import { Columns } from '../constants';
import { useTranslation } from 'react-i18next';

export const useColumns = () => {
    const { t } = useTranslation();
    const [columnsOrder, setColumnsOrder] = useSmartTableQuery('orders-columns');

    const columnsConfig = React.useMemo(
        () => [
            {
                key: Columns.SOLD_DATE,
                label: t('ticket.manager.orders.list.headers.date')
            },
            {
                key: Columns.BUYER,
                label: t('ticket.manager.orders.list.headers.buyers')
            },
            {
                key: Columns.ORDER_ID,
                label: t('ticket.manager.orders.list.headers.order_id')
            },
            {
                key: Columns.ORDER,
                label: t('ticket.manager.orders.list.headers.order')
            },
            {
                key: Columns.QUANTITY,
                label: t('ticket.manager.orders.list.headers.ticket')
            },
            {
                key: Columns.BUYING_PRICE,
                label: t('ticket.manager.orders.list.headers.buying_price')
            },
            {
                key: Columns.PAYMENT_TYPE,
                label: t('ticket.export.headers.payment_type')
            },
            {
                key: Columns.LANGUAGE,
                label: t('ticket.manager.orders.list.headers.language')
            },
            {
                key: Columns.STATUS,
                label: t('ticket.manager.orders.list.headers.statut')
            },
            {
                key: Columns.ACTIONS,
                label: t('ticket.manager.orders.list.headers.actions')
            }
        ],
        [t]
    );

    return useSmartTableWithQueryParams({
        columns: columnsConfig,
        defaultConfig: columnsConfig.map(column => ({
            key: column.key,
            hidden: [Columns.ORDER_ID, Columns.LANGUAGE].includes(column.key)
        })),
        queryParamState: {
            value: columnsOrder,
            onChange: setColumnsOrder
        }
    });
};
